const UNKNOWN_ERROR = "Oops!... Looks like an error occurred!"

export { UNKNOWN_ERROR }
